import * as React from 'react';
import { Select, SelectProps, Group, Text, createStyles } from '@mantine/core';
import { US, MX } from 'country-flag-icons/react/3x2';

const useStyles = createStyles(() => ({
    flagIcon: {
        '.flagIcon': {
            height: '12px'
        }
    },
    root: {
        width: '100%'
    },
    input: {
        // border: 'none'
    }
}));

const flags: Record<string, React.ReactNode> = {
    en: <US title="USA flag" className="flagIcon" />,
    es: <MX title="Mexico flag" className="flagIcon" />
};

interface ItemProps extends React.ComponentPropsWithoutRef<'div'> {
    label: string;
    value: string;
}

export const SelectItem = React.forwardRef<HTMLDivElement, ItemProps>(({ label, value, ...others }: ItemProps, ref) => {
    const Flag = flags[value];
    const { classes } = useStyles();

    return (
        <div ref={ref} {...others} data-cy={`language-select__option--${value}`}>
            <Group noWrap className={classes.flagIcon}>
                {Flag}
                <Text size="sm">{label}</Text>
            </Group>
        </div>
    );
});

interface LanguageSelectorProps extends Omit<SelectProps, 'data'> {
    onChange: (lang: string) => void;
    selectedLang?: string;
}

export const LanguageSelector: React.FC<LanguageSelectorProps> = ({ selectedLang, onChange, label, disabled }) => {
    const { classes } = useStyles();

    return (
        <Select
            label={label}
            data-cy="language-select"
            value={selectedLang}
            onChange={onChange}
            data={[
                {
                    value: 'en',
                    label: 'English'
                    // label: 'English'
                },
                { value: 'es', label: 'Español' }
            ]}
            itemComponent={SelectItem}
            classNames={{
                root: classes.root,
                input: classes.input
            }}
            disabled={disabled}
        />
    );
};
